"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearBasket = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _ClearBasketPopUp = require("./ClearBasketPopUp");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  justifyContent: 'center',
  padding: theme.spacing(3, 0)
}));
const ClearBasket = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    isEmptyBasket
  } = (0, _contexts.useBasketContext)();
  const [isClearBasketPopupVisible, setIsClearBasketPopupVisible] = (0, _react.useState)(false);
  const openClearBasketPopup = (0, _react.useCallback)(() => {
    setIsClearBasketPopupVisible(true);
  }, []);
  if (isEmptyBasket) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ClearBasketPopUp.ClearBasketPopUp, {
      visible: isClearBasketPopupVisible,
      setVisible: setIsClearBasketPopupVisible
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        "data-testid": getTestId('clear-basket'),
        variant: "outlined",
        onClick: openClearBasketPopup,
        children: formatMessage('clearBasket')
      })
    })]
  });
};
exports.ClearBasket = ClearBasket;